import { AccountType } from "shared-types";

export default AccountType;
